import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

type FilterState = {
  countryFilterList: string[];
  outcropFilterList: string[];
  fieldFilterList: string[];
  stratColFilterList: string[];
  groupFilterList: string[];
  gdeFilterList: string[];
  deFilterList: string[];
  seFilterList: string[];
  aeFilterList: string[];
  formationFilterList: string[];
  subzoneFilterList: string[];
  setCountryFilterList: (filters: string[]) => void;
  setOutcropFilterList: (filters: string[]) => void;
  setFieldFilterList: (filters: string[]) => void;
  setStratColFilterList: (filters: string[]) => void;
  setGroupFilterList: (filters: string[]) => void;
  setGdeFilterList: (filters: string[]) => void;
  setDeFilterList: (filters: string[]) => void;
  setSeFilterList: (filters: string[]) => void;
  setAeFilterList: (filters: string[]) => void;
  setFormationFilterList: (filters: string[]) => void;
  setSubzoneFilterList: (filters: string[]) => void;
};

export const useFilterStore = create<FilterState>()(
  devtools((set) => ({
    countryFilterList: [],
    outcropFilterList: [],
    fieldFilterList: [],
    stratColFilterList: [],
    groupFilterList: [],
    gdeFilterList: [],
    deFilterList: [],
    seFilterList: [],
    aeFilterList: [],
    formationFilterList: [],
    subzoneFilterList: [],
    setCountryFilterList: (filters: string[]) =>
      set({ countryFilterList: filters }, undefined, 'filter/country'),
    setOutcropFilterList: (filters: string[]) =>
      set({ outcropFilterList: filters }, undefined, 'filter/outcrop'),
    setFieldFilterList: (filters: string[]) =>
      set({ fieldFilterList: filters }, undefined, 'filter/field'),
    setStratColFilterList: (filters: string[]) =>
      set({ stratColFilterList: filters }, undefined, 'filter/stratCol'),
    setGroupFilterList: (filters: string[]) =>
      set({ groupFilterList: filters }, undefined, 'filter/group'),
    setGdeFilterList: (filters: string[]) =>
      set({ gdeFilterList: filters }, undefined, 'filter/gde'),
    setDeFilterList: (filters: string[]) =>
      set({ deFilterList: filters }, undefined, 'filter/de'),
    setSeFilterList: (filters: string[]) =>
      set({ seFilterList: filters }, undefined, 'filter/se'),
    setAeFilterList: (filters: string[]) =>
      set({ aeFilterList: filters }, undefined, 'filter/ae'),
    setFormationFilterList: (filters: string[]) =>
      set({ formationFilterList: filters }, undefined, 'filter/formation'),
    setSubzoneFilterList: (filters: string[]) =>
      set({ subzoneFilterList: filters }, undefined, 'filter/subzone'),
  })),
);
